// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"77bc1015","246":"6b31c189","254":"05cf94c1","373":"b67013fe","422":"66a032c3","658":"8dfcb3be"}[chunkId] + ".css";
};